import React from "react";

import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";

import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

class Selection extends React.Component {
  onSelectAll(e) {
    e.stopPropagation();

    const onSelectAll = this.props.onSelectAll || null;
    if (onSelectAll) {
      onSelectAll();
    }
  }

  onSelection(e, row) {
    e.stopPropagation();

    const onSelection = this.props.onSelection || null;
    if (onSelection) {
      onSelection(row);
    }
  }

  onInsert(e) {
    e.stopPropagation();

    const onInsert = this.props.onInsert || null;
    if (onInsert) {
      onInsert();
    }
  }

  onRemove(e, row) {
    e.stopPropagation();

    const onRemove = this.props.onRemove || null;
    if (onRemove) {
      onRemove(row);
    }
  }

  render() {
    const {
      type,
      numSelected,
      count,
      row,
      selected,
      hasSelection,
      isCreating,
      isLastRow,
    } = this.props;

    if (!hasSelection) {
      return null;
    }

    if (isCreating) {
      if (isLastRow) {
        return (
          <TableCell padding="checkbox">
            <IconButton size="small" onClick={(e) => this.onInsert(e)}>
              <AddIcon />
            </IconButton>
          </TableCell>
        );
      }

      return (
        <TableCell padding="checkbox">
          <IconButton size="small" onClick={(e) => this.onRemove(e, row)}>
            <RemoveIcon />
          </IconButton>
        </TableCell>
      );
    }

    if (type === "header") {
      return (
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < count}
            checked={count > 0 && numSelected === count}
            onChange={(e) => this.onSelectAll(e)}
          />
        </TableCell>
      );
    }

    const isItemSelected = selected.includes(row.id);

    return (
      <TableCell padding="checkbox">
        <Checkbox
          checked={isItemSelected}
          onClick={(e) => this.onSelection(e, row)}
        />
      </TableCell>
    );
  }
}

export default Selection;
